import axios from 'axios';
import { setAuthHeader } from 'Services/utils';
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
const SUPPORT_API_URL = process.env.REACT_APP_ACTIONS_API_URL;

const setUserSupportApiUrl = (userId) => {
  return `${SUPPORT_API_URL}/v2/actions/com/users/${userId}/zendesk`;
};

const getUserSupportTicketsById = async ({
  limit = 100,
  offset = 0,
  userId,
  userToken,
}) => {
  const request = `${setUserSupportApiUrl(
    userId
  )}?limit=${limit}&offset=${offset}`;
  const { data } = await axios.get(request, {
    ...setAuthHeader(userToken),
  });
  const { items, meta } = data;
  return {
    ids: Object.keys(items),
    total: meta.total,
    totalCount: meta.totalCount,
  };
};

const getUserSupportTickets = async ({
  limit = 100,
  offset = 0,
  userId,
  userToken,
}) => {
  try {
    const { ids, total, totalCount } = await getUserSupportTicketsById({
      limit,
      offset,
      userId,
      userToken,
    });

    if (!totalCount)
      return {
        expectedTicketCount: 0,
        expectedTotalCount: totalCount,
        ticketCount: 0,
        tickets: [],
      };

    const { data: tickets } = await axios.post(
      `${API_BASE_URL}/api/v1/zendesk`,
      { ids }
    );

    // Small chance the ticket count returned from the actions service
    // may not match the returned ticket data from zendesk,
    // keep track of counts for reference
    return {
      expectedTicketCount: total,
      expectedTotalCount: totalCount,
      ticketCount: tickets.length,
      tickets: tickets,
    };
  } catch (err) {
    throw err;
  }
};

export { getUserSupportTickets };
